module.exports = __webpack_public_path__ + "static/media/hayon5.bc6517cf.jpg";